export default [
  {
    position: "absolute",
    top: 3.7,
    left: 87.4,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "orgChartP2.mTitleTwo",
    mBody: "orgChartP2.mBodyTwo",
    isVideo: true,
    videoThumb: "SP-People-Bar-Thumb",
    videoURL: "SP-People-Bar.mp4",
    vidIcon: true,
    id: "SP_Homepage_Video_ManageTeam",
    index: 0
  },
  {
    position: "absolute",
    top: 0.5,
    left: 24,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    isAction: true,
    modal: false,
    mTitle: "homeDashboard.persona2.mTitleZero",
    mBody: "homeDashboard.persona2.mBodyZero",
    id: "SP_Homepage_Action_UniqueBranding",
    plusIcon: true,
    index: 1
  },
  {
    position: "absolute",
    top: 40,
    left: 82,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "homeDashboard.persona2.mTitleTwo",
    mBody: "homeDashboard.persona2.mBodyTwo",
    id: "SP_Homepage_Info_NewFaces",
    infoIcon: true,
    isAction: false,
    index: 2
  },
  {
    position: "absolute",
    top: 40,
    left: 64,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "homeDashboard.persona2.mTitleThree",
    mBody: "homeDashboard.persona2.mBodyThree",
    id: "SP_Homepage_Info_SocialMedia",
    infoIcon: true,
    isAction: false,
    index: 3
  },
  {
    position: "absolute",
    top: 67.8,
    left: 8,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-bottom-left",
    isDialog: true,
    modal: false,
    mTitle: "homeDashboard.persona2.mTitleFour",
    mBody: "homeDashboard.persona2.mBodyFour",
    id: "SP_Homepage_Navigation_Birthdays",
    infoIcon: true,
    isAction: false,
    index: 4
  },
  {
    position: "absolute",
    top: 89.7,
    left: 40.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 14,
    tooltipText: "homeDashboard.persona2.ttTextSeven",
    hover: false,
    id: "SP_Homepage_Navigation_Recognition",
    index: 5
  },
  {
    position: "absolute",
    top: 89.7,
    left: 89.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 15,
    tooltipText: "homeDashboard.persona2.ttTextEight",
    hover: false,
    id: "SP_Homepage_Navigation_OrgChart",
    index: 6
  },
  {
    position: "absolute",
    top: 0.7,
    left: 0.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 9,
    tooltipText: "homeDashboard.persona2.ttTextOne",
    hover: false,
    tooltipClass: "right",
    id: "SP_Homepage_Navigation_Menu",
    index: 7
  },
  {
    position: "absolute",
    top: 4.4,
    left: 35.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 3,
    tooltipText: "homeDashboard.persona2.ttTextTwo",
    hover: false,
    id: "SP_Homepage_Navigation_PayBenefits",
    index: 8
  },
  {
    position: "absolute",
    top: 4.4,
    left: 43.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 6,
    tooltipText: "homeDashboard.persona2.ttTextThree",
    hover: false,
    id: "SP_Homepage_Navigation_Absence",
    index: 9
  },
  {
    position: "absolute",
    top: 4.4,
    left: 50.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 7,
    tooltipText: "homeDashboard.persona2.ttTextFour",
    hover: false,
    id: "SP_Homepage_Navigation_Performance",
    index: 10
  },
  {
    position: "absolute",
    top: 4.4,
    left: 69.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 11,
    tooltipText: "homeDashboard.persona2.ttTextFive",
    hover: false,
    id: "SP_Homepage_Navigation_Hiring",
    index: 11
  },
  {
    position: "absolute",
    top: 3.6,
    left: 98.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "homeDashboard.persona2.ttTextSix",
    hover: false,
    tooltipClass: "left",
    id: "SP_Homepage_Navigation_TeamMember",
    index: 12
  },
];
